/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Dock_Locate_MeInputs */

const en_ui_dock_locate_me = /** @type {(inputs: Ui_Dock_Locate_MeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show my location`)
};

const de_ui_dock_locate_me = /** @type {(inputs: Ui_Dock_Locate_MeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meinen Standort zeigen`)
};

/**
* | output |
* | --- |
* | "Show my location" |
*
* @param {Ui_Dock_Locate_MeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_dock_locate_me = /** @type {((inputs?: Ui_Dock_Locate_MeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Dock_Locate_MeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_dock_locate_me(inputs)
	return de_ui_dock_locate_me(inputs)
});